import { DialogTitle } from '@mui/material'
import IconButton from '@mui/material/IconButton'
import CloseIcon from "../../../../assets/images/icons/buttons/closeIcon";

const DialogHeader = (props) => {
	const {
		title,
		onClose,
		isDownSm
	} = props
	return (
		<DialogTitle
			sx={{
				color: 'text.main',
				fontSize: '24px',
				lineHeight: '32px',
				fontWeight: 700,
				display: 'flex',
				flexDirection: 'row',
				alignItems: 'end',
				justifyContent: 'space-between',
				p: isDownSm ? 2 : 4, pt: 3, pb: 1
			}}
		>
			{title}
			<IconButton
				onClick={onClose}
			>
				<CloseIcon/>
			</IconButton>
		</DialogTitle>
	)
}

export default DialogHeader